import { render, staticRenderFns } from "./donateDetail.vue?vue&type=template&id=4cac480e&scoped=true"
import script from "./donateDetail.vue?vue&type=script&lang=js"
export * from "./donateDetail.vue?vue&type=script&lang=js"
import style0 from "./donateDetail.vue?vue&type=style&index=0&id=4cac480e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac480e",
  null
  
)

export default component.exports